import { render } from "./LargeTablePivoted.vue?vue&type=template&id=1a0b2bd0"
import script from "./LargeTablePivoted.vue?vue&type=script&lang=js"
export * from "./LargeTablePivoted.vue?vue&type=script&lang=js"

import "./LargeTablePivoted.vue?vue&type=style&index=0&id=1a0b2bd0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__